import { render } from "./MarketingPressure.vue?vue&type=template&id=706a6240"
import script from "./MarketingPressure.vue?vue&type=script&lang=ts"
export * from "./MarketingPressure.vue?vue&type=script&lang=ts"

import "./MarketingPressure.vue?vue&type=style&index=0&id=706a6240&lang=css"
script.render = render

export default script